import { useEffect } from "react";
import { useMediaQuery } from "../../../components/responsive/useMediaQuery";
import { DESKTOP_PLATFORM_MIN_WIDTH, LOCATION_PLATFORM } from "../locationConstants";
import { TLocationPlatform } from "../location.t";
import { locationSlice } from "../locationReducer";
import { useDispatch, useSelector } from "react-redux";
import { getAppFeatures } from "../../../app/appSelectors";
import { DEVICE_TYPES, FEATURES } from "../../../app/appConstants";
import _ from "lodash";
import Cookies from "universal-cookie";
import { clientDeviceType } from "../../../components/ClientInfo/ClientInfo";
import useRefCallback from "../../../hooks/useRefCallback";

interface IUseLocationPlatformWatchProps {
    platform?: TLocationPlatform;
}

const cookiesInstance = new Cookies();

function useLocationPlatformWatch(props: IUseLocationPlatformWatchProps) {
    const { platform } = props;

    const dispatch = useDispatch();
    const isDesktopPlatformMediaQuery = useMediaQuery(`(min-width: ${DESKTOP_PLATFORM_MIN_WIDTH}px)`);
    const features = useSelector(getAppFeatures);
    const currentPlatform: TLocationPlatform = platform || (
        features[FEATURES.DESKTOP] && isDesktopPlatformMediaQuery && clientDeviceType !== DEVICE_TYPES.MOBILE
            ? LOCATION_PLATFORM.DESKTOP
            : LOCATION_PLATFORM.MOBILE
    );

    const setHtmlPlatformDataAttribute = useRefCallback((platform: TLocationPlatform) => {
        const html = document.querySelector('html');
        if (!html) return;
        html.setAttribute('data-platform', platform);
    });

    useEffect(() => {
        if (platform || !_.isEmpty(features)) {
            dispatch(locationSlice.actions.updatePlatformAction(currentPlatform));
            cookiesInstance.set('app_platform', currentPlatform, { path: '/', maxAge: 60 * 60 * 24 * 7 });
            setHtmlPlatformDataAttribute(currentPlatform);
        }
    }, [dispatch, currentPlatform, features, platform, setHtmlPlatformDataAttribute]);
}

export default useLocationPlatformWatch;
